export default function AgreementLabel({buttonName = 'оформить заказ'} : {buttonName?: string}) {
    return (<> Нажимая на&nbsp;кнопку «{buttonName}», я соглашаюсь
        с договором <a href="/landing/29">оферты</a>, с <a href="/landing/26">политикой
            конфиденциальности</a> и <a href="/landing/27">политикой
            обработки cookies</a> и регистрируюсь в бонусной программе BAON</>)
}